import { render, staticRenderFns } from "./Margin.vue?vue&type=template&id=c4c1bd20&"
import script from "./Margin.vue?vue&type=script&lang=js&"
export * from "./Margin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports